<template>
  <div class="container my-4">
    <div class="row">
      <div class="col-8">
        <h1 class="mb-2">Trip Request</h1>
        <h6>{{ pickAndDrop }}</h6>
        <p>Distance: {{ distance }} km</p>
        <input
          type="text"
          class="form-control mb-2"
          style="width: 48%"
          v-model="distance"
        />
        <p>
          (Total weekly:<b>{{ countWeeklyTotalPrice.toFixed(4) }}</b> BDT)
        </p>
      </div>
      <div class="col-4">
        <div
          v-if="inputField.tripType == this.serviceTypeId.B2C"
          class="form-group mt-3"
        >
          <label for="parent_route_id"><b>Parent Route</b></label>
          <Multiselect
            v-model="parent_route_id"
            :closeOnSelect="true"
            :searchable="true"
            :options="parentRoutes"
            :resetAfter="true"
            placeholder="Select One"
            @change="parentRouteNameHandler"
          />
        </div>

        <!-- Dropdowns for B2B start -->
        <div
          v-if="inputField.tripType == this.serviceTypeId.B2B"
          class="form-group mt-3"
        >
          <label for="parent_route_id"><b>Company Code</b></label>
          <Multiselect
            v-model="company_code"
            :closeOnSelect="true"
            :searchable="true"
            :options="companyCodes"
            :resetAfter="true"
            placeholder="Select One"
          />
        </div>
        <div
          v-if="inputField.tripType == this.serviceTypeId.B2B && company_code"
          class="form-group mt-3"
        >
          <label for="parent_route_id"><b>Parent Route</b></label>
          <Multiselect
            v-model="parent_route_id"
            :closeOnSelect="true"
            :searchable="true"
            :options="companyParentRoutes"
            :resetAfter="true"
            placeholder="Select One"
            @change="companyParentRouteNameHandler"
          />
        </div>
        <!-- Dropdowns for B2B end -->
      </div>
    </div>
    <div>
      <form>
        <div class="row mb-3">
          <div class="col-4">
            <label for="">Fare per km</label>
            <input
              type="number"
              min="0"
              class="form-control mt-2"
              placeholder="Enter Here"
              v-model="inputField.priceInKM"
            />
          </div>
          <div class="col-4 py-1">
            <label for="tripStartDate">Trip Start Date</label>
            <Datepicker
              v-model="inputField.tripStartDate"
              placeholder="Start Typing ..."
              textInput
              autoApply
              required
              :enableTimePicker="false"
            />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-4">
            <div
              class="form-group"
              v-for="(homePickUpInput, index) in homePickUpInputs"
              :key="index"
            >
              <label for="">Home pickup time</label>
              <input
                type="time"
                class="form-control mt-2"
                placeholder="Enter Here"
                v-model="homePickUpInput.homePickTimes"
              /><span>
                <i
                  class="bi bi-plus-square-fill"
                  @click="addHomePickUpTime(index)"
                  v-show="index == homePickUpInputs.length - 1"
                >
                  Add</i
                >
                &nbsp;
                <i
                  class="bi bi-dash-circle-fill"
                  @click="removeHomePickUpTime(index)"
                  v-show="index || (!index && homePickUpInputs.length > 1)"
                >
                  Remove</i
                >
              </span>
            </div>
          </div>
          <div class="col-4 py-0">
            <div
              class="form-group"
              v-for="(officePickUpInput, index) in officePickUpInputs"
              :key="index"
            >
              <label for="">Office pickup time</label>
              <input
                type="time"
                class="form-control mt-2"
                placeholder="Enter Here"
                v-model="officePickUpInput.officePickTimes"
              /><span>
                <i
                  class="bi bi-plus-square-fill"
                  @click="addOfficePickUpTime(index)"
                  v-show="index == officePickUpInputs.length - 1"
                >
                  Add</i
                >
                &nbsp;
                <i
                  class="bi bi-dash-circle-fill"
                  @click="removeOfficePickUpTime(index)"
                  v-show="index || (!index && officePickUpInputs.length > 1)"
                >
                  Remove</i
                >
              </span>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <!--          <div class='col-4'>-->
          <!--            <label for=''>Working days</label>-->
          <!--            <select class='form-select mt-2' v-model='inputField.workDays'>-->
          <!--              <option selected value=''>Select</option>-->
          <!--              <option value='Sunday-Thursday(5 days)'>-->
          <!--                Sunday-Thursday (5 days)-->
          <!--              </option>-->
          <!--              <option value='Saturday-Thursday(6 days)'>-->
          <!--                Saturday-Thursday (6 days)-->
          <!--              </option>-->
          <!--            </select>-->
          <!--          </div>-->
          <div class="col-4">
            <label>Week day</label>
            <Multiselect
              v-model="this.inputField.workDays"
              mode="tags"
              :searchable="true"
              :createTag="true"
              :closeOnSelect="false"
              :resetAfter="true"
              :options="weekDayNameOptions"
              placeholder="Add week day"
            />
          </div>

          <div class="col-4 py-2">
            <label for="">Trip Type</label>
            <div class="mt-2" v-if="tripTypes.length">
              <template v-for="trip in tripTypes" :key="trip.id">
                <div class="form-check form-check-inline">
                  <input
                    @click="parentRouteDisplay"
                    class="form-check-input"
                    type="radio"
                    :id="trip.name"
                    :value="trip.id"
                    v-model="inputField.tripType"
                    :class="trip.name === 'B2B' ? 'checked' : ''"
                  />
                  <label class="form-check-label" :for="trip.name">{{
                    trip.name
                  }}</label>
                </div>
              </template>
            </div>
            <div class="mt-2" v-else>
              <p class="text-danger pt-2 pb-1 mr-2 pt-lg-2">
                No trip types available.
              </p>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-4">
            <label for="tm">Instruction for RM</label>
            <textarea
              class="form-control mt-2"
              id="tm"
              rows="2"
              v-model="inputField.tm"
              placeholder="Write Here..."
            ></textarea>
          </div>
          <div class="col-4">
            <label for="sp">Instruction for Partner</label>
            <textarea
              class="form-control mt-2"
              id="sp"
              rows="2"
              v-model="inputField.sp"
              placeholder="Write Here..."
            ></textarea>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-4">
            <label for="route_type">Route Type</label>
            <input
              type="text"
              readonly
              v-model="route_type"
              class="form-control"
            />
          </div>
        </div>

        <div class="row mb-5">
          <!--          <div class='col-8 text-end align-self-end'>-->
          <!--            <button-->
          <!--              type='button'-->
          <!--              class='btn next-button my-3'-->
          <!--              data-bs-toggle='modal'-->
          <!--              data-bs-target='#tripCreateModal'-->
          <!--              :class='isAllInputValid'-->
          <!--              @click='saveDataToLocalStorage'-->
          <!--            >-->
          <!--              Next-->
          <!--            </button>-->
          <!--          </div>-->

          <div class="col-8 text-end align-self-end">
            <button
              type="button"
              class="btn next-button my-3"
              data-bs-toggle="modal"
              data-bs-target="#bonusCreateModal"
              :class="isAllInputValid"
            >
              Next
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="tripCreateModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="allInputFieldFill"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header mx-2">
            <h5 class="modal-title" id="exampleModalLabel">TM Summary</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row mb-2">
              <div class="col-md-7">
                <div class="row">
                  <div class="col-md-4"><h6 class="">Route :</h6></div>
                  <div class="col-md-8">
                    <p class="adjust-row fw-normal">{{ pickAndDrop }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row">
                  <div class="col-md-7">
                    <h6 class="">Distance :</h6>
                  </div>
                  <div class="col-md-5">
                    <p class="adjust-row text-end fw-normal">
                      {{ distance }} km
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="">Fare per km :</h6>
                  </div>
                  <div class="col-md-8">
                    <!--                    <p class='adjust-row fw-normal'>-->
                    <!--                      {{ inputField.priceInKM }} BDT (Total Monthly :-->
                    <!--                      <span class='fw-bold'> {{ countTotalPrice }}</span> BDT) ||-->
                    <!--                      BDT (Total Weekly :-->
                    <!--                      <span class='fw-bold'> {{ countWeeklyTotalPrice }}</span> BDT)-->
                    <!--                    </p>-->
                    <p class="adjust-row fw-normal">
                      {{ inputField.priceInKM }}
                      BDT (Total Weekly :
                      <span class="fw-bold"> {{ countWeeklyTotalPrice }}</span>
                      BDT)
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4"><h6 class="">Bonus Type :</h6></div>
                  <div class="col-md-8">
                    <p
                      v-for="bonus in getBonusDetails"
                      :key="bonus"
                      class="adjust-row text-start fw-normal fs-8"
                      style="overflow: hidden; white-space: normal"
                    >
                      {{ bonus }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="">Weekdays :</h6>
                  </div>
                  <div class="col-md-8">
                    <span
                      v-for="data in inputField.workDays"
                      :key="data"
                      class="adjust-row fw-normal"
                    >
                      {{ data }},
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="">Home Pickup Time :</h6>
                  </div>
                  <div class="col-md-8">
                    <p class="adjust-row text-start fw-normal">
                      {{ homeTimeFormat }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="">Office Pickup Time :</h6>
                  </div>
                  <div class="col-md-8">
                    <p class="adjust-row text-start fw-normal">
                      {{ officeTimeFormat }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="">Instruction for RM :</h6>
                  </div>
                  <div class="col-md-8 text-start">
                    <p class="adjust-row fw-normal">
                      {{
                        inputField.tm.length > 25
                          ? `${inputField.tm.substring(0, 25)}...`
                          : inputField.tm
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="">Instruction for Partner :</h6>
                  </div>
                  <div class="col-md-8">
                    <p class="adjust-row fw-normal">
                      {{
                        inputField.sp.length > 25
                          ? `${inputField.sp.substring(0, 25)}...`
                          : inputField.sp
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4">
                    <h6 class="">Trip Start Date :</h6>
                  </div>
                  <div class="col-md-8">
                    <p class="adjust-row fw-normal">
                      {{ tripStartDateFormat }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <h6 class="">Pickup Points</h6>
            <div class="row mt-3 mb-2">
              <div class="col-12">
                <div class="row fw-normal" :style="styleCal">
                  <template v-if="pickData.length === 2">
                    <div class="col-10">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[1].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 3">
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[2].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 4">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-4">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[3].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="pickData.length === 5">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[1].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[3].name }}</p>
                    </div>
                    <div class="col-1">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-record-circle-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ pickData[4].name }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="pick in pickData" :key="pick.name">
                      <div :class="calculateColPick">
                        <div class="contacts-row">
                          <div>
                            <i class="bi bi-record-circle-fill"></i>
                          </div>
                          <div class="dots"></div>
                        </div>
                        <p class="mt-0 p-0 px-2">{{ pick.name }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
            <h6 class="">Drop Points</h6>
            <div class="row mt-3">
              <div class="col-12 fw-normal">
                <div class="row" :style="styleCal">
                  <template v-if="dropData.length === 2">
                    <div class="col-10">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[1].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 3">
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-5">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[2].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 4">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-4">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[3].name }}</p>
                    </div>
                  </template>
                  <template v-else-if="dropData.length === 5">
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[0].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[1].name }}</p>
                    </div>
                    <div class="col-3">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[2].name }}</p>
                    </div>
                    <div class="col-2">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[3].name }}</p>
                    </div>
                    <div class="col-1">
                      <div class="contacts-row">
                        <div>
                          <i class="bi bi-geo-alt-fill"></i>
                        </div>
                        <div class="dots"></div>
                      </div>
                      <p class="mt-0 p-0 px-2">{{ dropData[4].name }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <template v-for="drop in dropData" :key="drop.name">
                      <div :class="calculateColDrop">
                        <div class="contacts-row">
                          <div>
                            <i class="bi bi-geo-alt-fill"></i>
                          </div>
                          <div class="dots"></div>
                        </div>
                        <p class="mt-0 p-0">{{ drop.name }}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <!-- <router-link to=""> </router-link> -->
            <button
              class="btn"
              data-bs-dismiss="modal"
              @click="editHandler"
              style="background: none; color: black"
            >
              Edit Info
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="confirmSubmit"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <!-- Modal -->
    <div
      class="modal fade"
      id="bonusCreateModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="bonusCreateModal">Bonus</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="col-md-12">
              <div class="row mb-3">
                <div class="col-4">
                  <label for="">Bonus</label>
                  <Multiselect
                    v-model="this.bonusObject.bonusId"
                    mode="tags"
                    :searchable="true"
                    :createTag="true"
                    :closeOnSelect="false"
                    :resetAfter="true"
                    :options="bonusList"
                    @deselect="onRemoveBonusInput"
                    placeholder="Add Bonus Type"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-4">
                  <div class="row form-group">
                    <div
                      class="col-6"
                      id="shuttleBonusType"
                      style="display: none"
                    >
                      <label
                        for=""
                        class="col-sm col-form-label col-form-label-sm fw-bold"
                        >Shuttle Bonus Type</label
                      >
                      <select
                        class="form-select"
                        v-model="bonusObject.shuttleBonus"
                      >
                        <option value="Flat">Flat</option>
                        <option value="percentage">percentage</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-6" id="flatAmount" style="display: none">
                      <label
                        for=""
                        class="col-sm col-form-label col-form-label-sm"
                      >
                        Flat Amount</label
                      >
                      <input
                        type="text"
                        class="form-control mt-0"
                        v-model="bonusObject.shuttleBonusFlatAmount"
                      />
                    </div>
                    <div class="col-6" id="percentAmount" style="display: none">
                      <label
                        for=""
                        class="col-sm col-form-label col-form-label-sm"
                      >
                        Percent Amount</label
                      >
                      <input
                        type="text"
                        class="form-control mt-0"
                        v-model="bonusObject.shuttleBonusPercentAmount"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="col-4"
                  id="CompletionBonusAmount"
                  style="display: none"
                >
                  <label
                    for=""
                    class="col-sm col-form-label col-form-label-sm fw-bold"
                  >
                    Completion Bonus</label
                  >
                  <br />
                  <label for="" class="col-sm col-form-label col-form-label-sm">
                    Bonus Amount</label
                  >
                  <input
                    type="text"
                    class="form-control mt-0"
                    v-model="bonusObject.CompletionBonusAmount"
                  />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4" id="timeBonus" style="display: none">
                  <label
                    for=""
                    class="col-sm col-form-label col-form-label-sm fw-bold"
                  >
                    Time Bonus</label
                  >
                  <div class="row form-group">
                    <div class="col-6">
                      <label
                        for=""
                        class="col-sm col-form-label col-form-label-sm"
                      >
                        Per KM Travel Time</label
                      >
                      <input
                        type="text"
                        class="form-control mt-0"
                        v-model="bonusObject.travelTimePerKM"
                      />
                    </div>
                    <div class="col-6">
                      <label
                        for=""
                        class="col-sm col-form-label col-form-label-sm"
                      >
                        Bonus Per Minute</label
                      >
                      <input
                        type="text"
                        class="form-control mt-0"
                        v-model="bonusObject.bonusPerMinutesForKM"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <div class="col-8 text-end align-self-end">
              <button
                type="button"
                class="btn next-button my-3"
                data-bs-toggle="modal"
                data-bs-target="#tripCreateModal"
                :class="isAllInputValid"
                @click="saveDataToLocalStorage"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import Datepicker from 'vue3-date-time-picker';
import http from '../config/axios.js';
import numberFormat from '../helpers/formatNumber.js';

// import { ref } from 'vue';
/* eslint-disable */
export default {
  components: {
    Datepicker,
    Multiselect
  },
  name: 'TripRequestForm',
  data() {
    return {
      distance: 0,
      pickData: [],
      dropData: [],
      pickName: '',
      dropName: '',
      tripTypes: [],
      allInputFieldFill: false,
      inputField: {
        priceInKM: '',
        bonus: '',
        homePickTime: '',
        homeFormatTime: '',
        officePickTime: '',
        officeFormatTime: '',
        workDays: [],
        tripType: '',
        tm: '',
        sp: '',
        tripStartDate: new Date()
      },
      serviceTypeId: {},
      homePickUpInputs: [
        {
          homePickTimes: ''
        }
      ],
      officePickUpInputs: [
        {
          officePickTimes: ''
        }
      ],
      weekDayNameOptions: [
        { value: 'Saturday', label: 'Saturday' },
        { value: 'Sunday', label: 'Sunday' },
        { value: 'Monday', label: 'Monday' },
        { value: 'Tuesday', label: 'Tuesday' },
        { value: 'Wednesday', label: 'Wednesday' },
        { value: 'Thursday', label: 'Thursday' },
        { value: 'Friday', label: 'Friday' }
      ],
      bonusList: [],
      ttt: [],
      bonusObject: {
        bonusId: [],
        shuttleBonus: '',
        shuttleBonusFlatAmount: '',
        shuttleBonusPercentAmount: '',
        CompletionBonusAmount: '',
        travelTimePerKM: '',
        bonusPerMinutesForKM: ''
      },
      route_type: '',
      parentRoutes: [],
      companyCodes: [],
      company_code: '',
      companyParentRoutes: [],
      parent_route_id: null,
      parent_route_name: '',
      parentRouteDisplayClass: 'd-none'
    };
  },
  // created() {
  //   this.getTripType();
  //   this.getBonusList();
  // },
  // beforeMount() {
  //   this.getTripType();
  //   this.getBonusList();
  // },
  mounted() {
    this.loadParenRoutes();
    this.loadCompanyCodes();
    this.getTripType();
    this.getBonusList();
    // this.setLocalStorageValue();
    this.distance = Number(window.localStorage.getItem('distance'));
    this.pickData = JSON.parse(window.localStorage.getItem('pickData'));
    this.dropData = JSON.parse(window.localStorage.getItem('dropData'));
    this.pickName = this.pickData[0].name.split(',')[0];
    this.dropName = this.dropData[this.dropData.length - 1].name.split(',')[0];
    this.$forceUpdate();
  },

  methods: {
    loadParenRoutes() {
      http.get('v2/parent/routes').then((response) => {
        let parentRoutesData = response.data.data;
        parentRoutesData.forEach((object) => {
          this.parentRoutes.push({
            value: object.parent_route_id,
            label: object.name
          });
        });
      });
    },

    loadCompanyCodes() {
      http.get('v2/company/lists').then((response) => {
        let companyCodeData = response.data.data.data;
        companyCodeData.forEach((object) => {
          this.companyCodes.push({
            value: object.companyCode,
            label: object.name
          });
        });
      });
    },

    loadCompanyParentRoutes() {
      http
        .get(`v2/routes/by/compnay?companyCode=${this.company_code}`)
        .then((response) => {
          let parentRoutesData = response.data.data.data;
          this.companyParentRoutes = [];
          parentRoutesData.forEach((object) => {
            this.companyParentRoutes.push({
              value: object.id,
              label: object.name
            });
          });
        });
    },

    parentRouteDisplay(e) {
      let tripTypeId = e.target.value;
      if (tripTypeId == this.serviceTypeId.B2C) {
        this.parentRouteDisplayClass = 'd-block';
      } else {
        this.parentRouteDisplayClass = 'd-none';
      }
    },

    parentRouteNameHandler(id) {
      this.parentRoutes.filter((route) => {
        if (route.value == id) {
          this.parent_route_name = route.label;
        }
      });
    },

    companyParentRouteNameHandler(id) {
      this.companyParentRoutes.filter((route) => {
        if (route.value == id) {
          this.parent_route_name = route.label;
        }
      });
    },

    confirmSubmit() {
      let workDays = this.inputField.workDays;
      let splitWeekDays = workDays;
      let week_days = this.inputField.workDays.join(',');
      let working_days = splitWeekDays.length;
      let pickup_time = [
        // { time: this.formatHomeTime, type: 'HomePickUp' },
        this.formatHomeTime(),
        this.formatOfficeTime()
      ];

      let pd = this.pickData.map((pick) => {
        return {
          name: pick.name,
          latitude: pick.lat,
          longitude: pick.lng,
          type: 'PickUp'
        };
      });
      let dd = this.dropData.map((drop) => {
        return {
          name: drop.name,
          latitude: drop.lat,
          longitude: drop.lng,
          type: 'DropOff'
        };
      });
      let tripStartDate = new Date(this.inputField.tripStartDate)
        .toISOString()
        .substring(0, 10);
      let postData = {
        distance: this.distance,
        route_name: this.pickName + ' - ' + this.dropName,
        trip_per_price: this.inputField.priceInKM,
        // bonus: this.inputField.bonus.split(',').join(''),
        working_days: working_days,
        week_days: week_days,
        trip_type: this.inputField.tripType,
        instruction_for_tm: this.inputField.tm,
        instruction_for_sp: this.inputField.sp,
        pickUpTime: pickup_time.flat(),
        points: pd.concat(dd),
        trip_start_date: tripStartDate,
        route_type: this.route_type,
        company_code: this.company_code,
        parent_route_id: this.parent_route_id,
        parent_route_name: this.parent_route_name
      };

      http
        .post('v2/partners/triprequests', postData)
        .then((res) => {
          if (res.data.success) {
            window.localStorage.setItem('trip', JSON.stringify(res.data.data));
            this.confirmBonusSubmit(res.data.data.tripRequest.id);
            this.allInputFieldFill = false;
            document
              .getElementById('tripCreateModal')
              .addEventListener('hidden.bs.modal', function () {});
            this.$swal({
              position: 'center',
              icon: 'success',
              title: 'Trip Request',
              text: res.data.message,
              showConfirmButton: true
            }).then((result) => {
              if (result.isConfirmed) {
                window.localStorage.removeItem('distance');
                window.localStorage.removeItem('pickData');
                window.localStorage.removeItem('dropData');
                window.localStorage.removeItem('tripSummaryData');
                // this.$router.push('/partners');
                this.$router.push({
                  name: 'partners'
                });
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confirmBonusSubmit(tripRequestId) {
      let bonusObject = this.bonusObject.bonusId.map((bonusObject) => {
        if (
          this.bonusList?.find((data) => data.value == bonusObject).label ===
            'Shuttle Bonus' &&
          this.bonusObject.shuttleBonus === 'Flat'
        ) {
          return {
            bonus_id: this.bonusList.find((data) => data.value == bonusObject)
              .value,
            type: this.bonusObject.shuttleBonus,
            base_bonus: this.bonusObject.shuttleBonusFlatAmount
          };
        }
        if (
          this.bonusList?.find((data) => data.value == bonusObject).label ===
            'Shuttle Bonus' &&
          this.bonusObject.shuttleBonus === 'percentage'
        ) {
          return {
            bonus_id: this.bonusList.find((data) => data.value == bonusObject)
              .value,
            type: this.bonusObject.shuttleBonus,
            base_bonus: this.bonusObject.shuttleBonusPercentAmount
          };
        }

        if (
          this.bonusList?.find((data) => data.value == bonusObject).label ===
          'Completion Bonus'
        ) {
          return {
            bonus_id: this.bonusList.find((data) => data.value == bonusObject)
              .value,
            type: 'null',
            base_bonus: this.bonusObject.CompletionBonusAmount
          };
        }

        if (
          this.bonusList?.find((data) => data.value == bonusObject).label ===
          'Time Bonus'
        ) {
          return {
            bonus_id: this.bonusList.find((data) => data.value == bonusObject)
              .value,
            condition: {
              per_km_travel_time: this.bonusObject.travelTimePerKM,
              bonus_per_minute: this.bonusObject.bonusPerMinutesForKM
            }
          };
        }
      });

      let paramObject = {
        trip_requests_id: tripRequestId,
        bonus: bonusObject
      };
      http
        .post('v2/partners/bonus/trip-requests', paramObject)
        .then((res) => {
          if (res.data.success) {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatTripBonus() {
      if (
        this.inputField.bonus.trim() === '' ||
        /[a-zA-Z]/g.test(this.inputField.bonus)
      ) {
        this.inputField.bonus = '0';
      }
      this.inputField.bonus = this.inputField.bonus.replace(/[^0-9]/g, '');
      this.inputField.bonus = numberFormat(this.inputField.bonus);
    },
    editHandler() {
      // router push to trip create page
      this.$router.push({
        name: 'trip-create'
      });
    },
    addHomePickUpTime() {
      this.homePickUpInputs.push({
        homePickTimes: ''
      });
    },
    removeHomePickUpTime(index) {
      this.homePickUpInputs.splice(index, 1);
    },
    addOfficePickUpTime() {
      this.officePickUpInputs.push({
        officePickTimes: ''
      });
    },
    removeOfficePickUpTime(index) {
      this.officePickUpInputs.splice(index, 1);
    },
    formatHomeTime() {
      let timeArray = [];
      this.homePickUpInputs.forEach((value) => {
        if (value.homePickTimes.length) {
          let time = value.homePickTimes;
          let [hours, minutes] = time.split(':');
          let ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12;
          hours = hours ? hours : 12;
          let format = `${hours}:${minutes} ${ampm}`;

          timeArray.push({
            time: format,
            type: 'HomePickUp'
          });
        }
      });
      return timeArray;
    },
    formatOfficeTime() {
      let timeArray = [];
      this.officePickUpInputs.forEach((value) => {
        if (value.officePickTimes.length) {
          let time = value.officePickTimes;
          let [hours, minutes] = time.split(':');
          let ampm = hours >= 12 ? 'PM' : 'AM';
          hours = hours % 12;
          hours = hours ? hours : 12;
          let format = `${hours}:${minutes} ${ampm}`;

          timeArray.push({
            time: format,
            type: 'OfficePickUp'
          });
        }
      });
      return timeArray;
    },
    saveDataToLocalStorage() {
      let workDays = this.inputField.workDays;
      let splitWeekDays = workDays;
      let week_days = workDays.join(',');
      let working_days = splitWeekDays.length;
      let pickup_time = [
        // { time: this.formatHomeTime, type: 'HomePickUp' },
        this.formatHomeTime(),
        this.formatOfficeTime()
      ];

      let bonusObject = this.bonusObject.bonusId.map((bonusObject) => {
        if (
          this.bonusList.find((data) => data.value == bonusObject).label ===
            'Shuttle Bonus' &&
          this.bonusObject.shuttleBonus === 'Flat'
        ) {
          return {
            bonus_id: this.bonusList.find((data) => data.value == bonusObject)
              .value,
            type: this.bonusObject.shuttleBonus,
            base_bonus: this.bonusObject.shuttleBonusFlatAmount
          };
        }
        if (
          this.bonusList.find((data) => data.value == bonusObject).label ===
            'Shuttle Bonus' &&
          this.bonusObject.shuttleBonus === 'percentage'
        ) {
          return {
            bonus_id: this.bonusList.find((data) => data.value == bonusObject)
              .value,
            type: this.bonusObject.shuttleBonus,
            base_bonus: this.bonusObject.shuttleBonusPercentAmount
          };
        }

        if (
          this.bonusList.find((data) => data.value == bonusObject).label ===
          'Completion Bonus'
        ) {
          return {
            bonus_id: this.bonusList.find((data) => data.value == bonusObject)
              .value,
            type: 'null',
            base_bonus: this.bonusObject.CompletionBonusAmount
          };
        }

        // if (this.bonusList.find((data) => data.value == bonusObject).label === 'Bonus Time') {
        //   return {
        //     'bonus_id': this.bonusList.find((data) => data.value == bonusObject).value,
        //     'type': 'null',
        //     'base_bonus': this.bonusObject.CompletionBonusAmount
        //   };
        // }
      });

      let pd = this.pickData.map((pick) => {
        return {
          name: pick.name,
          latitude: pick.lat,
          longitude: pick.lng,
          type: 'PickUp'
        };
      });
      let dd = this.dropData.map((drop) => {
        return {
          name: drop.name,
          latitude: drop.lat,
          longitude: drop.lng,
          type: 'DropOff'
        };
      });
      let tripStartDate = new Date(this.inputField.tripStartDate)
        .toISOString()
        .substring(0, 10);
      let postData = {
        distance: this.distance,
        route_name: this.pickName + ' - ' + this.dropName,
        trip_per_price: this.inputField.priceInKM,
        // bonus: this.inputField.bonus.split(',').join(''),
        working_days: working_days,
        week_days: week_days,

        trip_type: this.inputField.tripType,
        instruction_for_tm: this.inputField.tm,
        instruction_for_sp: this.inputField.sp,
        pickUpTime: pickup_time.flat(),
        points: pd.concat(dd),
        trip_start_date: tripStartDate,
        bonus: bonusObject,
        route_type: this.route_type
      };
      localStorage.setItem('tripSummaryData', JSON.stringify(postData));
    },
    getBonusList() {
      http.get('/v2/partners/bonus').then(
        (response) => {
          let bonusResponse = response.data.data;
          bonusResponse.forEach((object) => {
            this.bonusList.push({
              value: object.id,
              label: object.bonus_name
            });
          });
          setTimeout(() => {
            this.setLocalStorageValue();
          }, 1000);
        },
        (error) => {
          console.log(error);
        }
      );
    },
    setLocalStorageValue() {
      var getLocalData = JSON.parse(localStorage.getItem('tripSummaryData'));

      if (getLocalData?.trip_per_price) {
        this.inputField.priceInKM = getLocalData.trip_per_price;
      }
      if (getLocalData?.bonus) {
        getLocalData.bonus.forEach((bonus) => {
          let isFound = this.bonusList.find(
            (bonusList) => bonusList.value === bonus.bonus_id
          );
          if (isFound && isFound.label === 'Shuttle Bonus') {
            this.bonusObject.bonusId.push(
              this.bonusList.find(
                (bonusList) => bonusList.value == bonus.bonus_id
              ).value
            );
            if (bonus.type === 'Flat') {
              this.bonusObject.shuttleBonus = bonus.type;
              this.bonusObject.shuttleBonusFlatAmount = bonus.base_bonus;
            }
            if (bonus.type === 'percentage') {
              this.bonusObject.shuttleBonus = bonus.type;
              this.bonusObject.shuttleBonusPercentAmount = bonus.base_bonus;
            }
          }

          if (isFound && isFound.label === 'Completion Bonus') {
            this.bonusObject.bonusId.push(
              this.bonusList.find(
                (bonusList) => bonusList.value == bonus.bonus_id
              ).value
            );
            this.bonusObject.CompletionBonusAmount = bonus.base_bonus;
          }
        });
      }

      if (getLocalData?.instruction_for_tm) {
        this.inputField.tm = getLocalData.instruction_for_tm;
      }

      if (getLocalData?.instruction_for_sp) {
        this.inputField.sp = getLocalData.instruction_for_sp;
      }

      if (getLocalData?.trip_start_date) {
        this.inputField.tripStartDate = getLocalData.trip_start_date;
      }

      if (getLocalData?.pickUpTime) {
        this.homePickUpInputs.length = 0;
        let pickTimeFilter = getLocalData.pickUpTime.filter(function (item) {
          return item.type == 'HomePickUp';
        });

        for (let i = 0; i < pickTimeFilter.length; i++) {
          let d = new Date('2000-01-01 ' + pickTimeFilter[i].time);
          let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
          let minutes =
            d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
          this.homePickUpInputs.push({ homePickTimes: `${hour}:${minutes}` });
        }
      }

      if (getLocalData?.pickUpTime) {
        this.officePickUpInputs.length = 0;
        let officeTimeFilter = getLocalData.pickUpTime.filter(function (item) {
          return item.type == 'OfficePickUp';
        });

        for (let i = 0; i < officeTimeFilter.length; i++) {
          let d = new Date('2000-01-01 ' + officeTimeFilter[i].time);
          let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
          let minutes =
            d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes();
          this.officePickUpInputs.push({
            officePickTimes: `${hour}:${minutes}`
          });
        }
      }
      if (getLocalData?.trip_type) {
        this.inputField.tripType = getLocalData.trip_type;
      }
      // if (getLocalData?.working_days) {
      //   if (getLocalData.working_days == 5) {
      //     this.inputField.workDays = `${'Sunday-Thursday(5 days)'}`;
      //   } else {
      //     this.inputField.workDays = `${'Saturday-Thursday(6 days)'}`;
      //   }
      // }
      if (getLocalData?.week_days) {
        let getWeekDay = getLocalData.week_days;
        getWeekDay.split(',').forEach((value) => {
          this.inputField.workDays.push(value);
        });
      }
    },
    getTripType() {
      http.get('v2/trips/types').then((res) => {
        this.tripTypes = res.data.data;
        this.tripTypes.forEach((ele) => {
          this.serviceTypeId[ele.name] = ele.id;
        });
      });
    },

    onRemoveBonusInput(opt) {
      var shuttleBonusType = document.getElementById('shuttleBonusType');
      var CompletionBonusAmount = document.getElementById(
        'CompletionBonusAmount'
      );
      var timeBonus = document.getElementById('timeBonus');
      var flatAmount = document.getElementById('flatAmount');
      var percentAmount = document.getElementById('percentAmount');

      if (
        this.bonusList.find((object) => object.value === opt).label ===
        'Time Bonus'
      ) {
        timeBonus.style.display = 'none';
      }
      if (
        this.bonusList.find((object) => object.value === opt).label ===
        'Completion Bonus'
      ) {
        CompletionBonusAmount.style.display = 'none';
      }
      if (
        this.bonusList.find((object) => object.value === opt).label ===
        'Shuttle Bonus'
      ) {
        shuttleBonusType.style.display = 'none';
        flatAmount.style.display = 'none';
        percentAmount.style.display = 'none';
      }
    }
  },
  computed: {
    pickAndDrop() {
      return this.pickName + ' - ' + this.dropName;
    },
    isAllInputValid() {
      // let officeCount = 0;
      // let homeCount = 0;
      //
      // this.homePickUpInputs.forEach(value => {
      //   if (value.homePickTimes != false) {
      //     homeCount++;
      //   }
      // });
      //
      // this.officePickUpInputs.forEach(value => {
      //   if (value.officePickTimes != false) {
      //     officeCount++;
      //   }
      // });

      if (
        this.inputField.priceInKM &&
        // homeCount > 0 &&
        // officeCount > 0 &&
        // this.inputField.homePickTime &&
        // this.inputField.officePickTime &&
        // this.inputField.workDays.length > 0 &&
        this.inputField.tripType
      ) {
        this.allInputFieldFill = true;
        return '';
      } else {
        return 'disabled';
      }
    },

    homeTimeFormat() {
      let time = this.formatHomeTime();
      return time.map((t) => t.time).join(',');
    },
    officeTimeFormat() {
      let time = this.formatOfficeTime();
      return time.map((t) => t.time).join(',');
    },
    calculateColPick() {
      if (this.pickData.length > 6) {
        return 'col-2';
      }
      return 'col-' + Math.floor(12 / this.pickData.length);
    },
    calculateColDrop() {
      if (this.dropData.length > 0) {
        return 'col-2';
      }
      return 'col-' + Math.floor(12 / this.dropData.length);
    },
    styleCal() {
      if (this.pickData.length === 5 && this.dropData.length === 5) {
        return '--bs-gutter-x: 0; width: 53.8rem';
      }
      return '--bs-gutter-x: 0';
    },
    countTotalPrice() {
      let price = this.inputField.priceInKM;
      let workDays = this.inputField.workDays;
      let trip = 22; // number of trips with 5 working days in a month
      let total = 0;
      if (workDays && price) {
        let splitWeekDays = workDays.split('(');
        let working_days = splitWeekDays[1].split(' ')[0];
        if (working_days === '6') {
          trip = 26; // number of trips with 6 working days in a month
        }
        total = numberFormat(
          Math.round(trip * 2 * Number(price) * this.distance)
        );
      }
      return total;
    },
    countWeeklyTotalPrice() {
      let price = this.inputField.priceInKM;
      let workDays = this.inputField.workDays;
      let officeCount = 0;
      let homeCount = 0;

      this.homePickUpInputs.forEach((value) => {
        if (value.homePickTimes != false) {
          homeCount++;
        }
      });

      this.officePickUpInputs.forEach((value) => {
        if (value.officePickTimes != false) {
          officeCount++;
        }
      });

      let homePickTimeLength = homeCount;
      let officePickTimeLength = officeCount;

      let total = 0;
      if (workDays && price) {
        let splitWeekDays = workDays;
        let working_days = splitWeekDays.length;

        total =
          Number(price) *
          this.distance *
          (homePickTimeLength + officePickTimeLength) *
          Number(working_days);
      }
      return total;
    },
    tripStartDateFormat() {
      return new Date(this.inputField.tripStartDate)
        .toISOString()
        .substring(0, 10);
    },
    getBonusDetails() {
      let bonusArray = [];
      this.bonusObject.bonusId.map((bonusObject) => {
        // bonusArray.push(this.bonusList.find((data) => data.value == bonusObject).label, this.bonusObject.shuttleBonus ? this.bonusObject.shuttleBonus : 'Null');
        let isFound = this.bonusList.find((data) => data.value == bonusObject);

        if (
          isFound &&
          isFound.label === 'Shuttle Bonus' &&
          this.bonusObject.shuttleBonus === 'Flat'
        ) {
          bonusArray.push(
            'Shuttle Bonus' +
              ': Flat - ' +
              this.bonusObject.shuttleBonusFlatAmount
          );
          // let payload = `${isFound.label, this.bonusObject.shuttleBonus} : ${(item.base_bonus)}`;
          // return payload;
        }

        if (
          isFound &&
          isFound.label === 'Shuttle Bonus' &&
          this.bonusObject.shuttleBonus === 'percentage'
        ) {
          bonusArray.push(
            'Shuttle Bonus' +
              ': Percent - ' +
              this.bonusObject.shuttleBonusPercentAmount +
              ' %'
          );
        }

        if (isFound && isFound.label === 'Completion Bonus') {
          bonusArray.push(
            'Completion Bonus: ' + ' ' + this.bonusObject.CompletionBonusAmount
          );
        }

        if (isFound && isFound.label === 'Time Bonus') {
          bonusArray.push(
            'Time Bonus' +
              ': Time Per KM - ' +
              this.bonusObject.travelTimePerKM +
              ', Minutes For KM - ' +
              this.bonusObject.bonusPerMinutesForKM
          );
        }
      });

      return bonusArray;
    }
  },
  watch: {
    'bonusObject.bonusId': {
      handler: function (value) {
        var shuttleBonusType = document.getElementById('shuttleBonusType');
        var CompletionBonusAmount = document.getElementById(
          'CompletionBonusAmount'
        );
        var timeBonus = document.getElementById('timeBonus');

        var flatAmount = document.getElementById('flatAmount');
        var percentAmount = document.getElementById('percentAmount');

        value.forEach((data) => {
          let isFound = this.bonusList.find((object) => object.value === data);
          if (isFound && isFound.label === 'Shuttle Bonus') {
            shuttleBonusType.style.display = 'block';
          }
          if (isFound && isFound.label === 'Completion Bonus') {
            CompletionBonusAmount.style.display = 'block';
          }
          if (isFound && isFound.label === 'Time Bonus') {
            timeBonus.style.display = 'block';
          }
        });

        if (this.bonusObject.bonusId.length == 0) {
          shuttleBonusType.style.display = 'none';
          CompletionBonusAmount.style.display = 'none';
          timeBonus.style.display = 'none';
          flatAmount.style.display = 'none';
          percentAmount.style.display = 'none';
        }
      },
      deep: true
    },
    'bonusObject.shuttleBonus': {
      handler: function (value) {
        var flatAmount = document.getElementById('flatAmount');
        var percentAmount = document.getElementById('percentAmount');

        if (this.bonusObject.shuttleBonus == 'Flat') {
          flatAmount.style.display = 'block';
        } else {
          flatAmount.style.display = 'none';
        }

        if (this.bonusObject.shuttleBonus == 'percentage') {
          percentAmount.style.display = 'block';
        } else {
          percentAmount.style.display = 'none';
        }
      },
      deep: true
    },
    homePickUpInputs: {
      handler: function (value) {
        value.forEach((value) => {
          if (
            value.homePickTimes.length > 0 ||
            this.officePickUpInputs.length > 0
          ) {
            this.route_type = 'One way';
          }
          if (
            value.homePickTimes.length > 0 &&
            this.officePickUpInputs[0]['officePickTimes'] &&
            this.officePickUpInputs.length > 0
          ) {
            this.route_type = 'Both way';
          }
          if (
            value.homePickTimes.length == 0 &&
            this.officePickUpInputs[0]['officePickTimes'].length == 0
          ) {
            this.route_type = '';
          }
        });
      },
      deep: true
    },
    officePickUpInputs: {
      handler: function (value) {
        value.forEach((data) => {
          if (
            data.officePickTimes.length > 0 ||
            this.homePickUpInputs.length > 0
          ) {
            this.route_type = 'One way';
          }
          if (
            data.officePickTimes.length > 0 &&
            this.homePickUpInputs[0]['homePickTimes'] &&
            this.homePickUpInputs.length > 0
          ) {
            this.route_type = 'Both way';
          }

          if (
            data.officePickTimes.length == 0 &&
            this.homePickUpInputs[0]['homePickTimes'].length == 0
          ) {
            this.route_type = '';
          }
        });
      },
      deep: true
    },
    company_code: function () {
      this.loadCompanyParentRoutes();
    },
    'inputField.tripType': function () {
      this.company_code = '';
      this.parent_route_id = '';
    }
  }
};
</script>

<style scoped>
@import '~@vueform/multiselect/themes/default.css';

input[type='text'],
textarea,
select {
  background: #f0f2f5;
}

.form-check-input:checked {
  background-color: #494545;
  border-color: #494545;
}

.form-check-input:focus {
  box-shadow: none;
}

.next-button {
  width: 22.2rem;
  background: #262c66;
  border-radius: 4px;
  color: #fff;
  font-size: 1rem;
}

.next-button:hover,
.next-button:focus,
.next-button:active {
  background: #262c66;
}

.modal-header .btn-close {
  font-size: 10px;
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.contacts-row {
  display: flex;
  width: 100%;
}

.dots {
  display: inline-flex;
  background: radial-gradient(circle, #c4c4c4 2px, transparent 2px) repeat-x;
  background-size: 10px 25px;
  border: none;
  flex-grow: 5;
  margin-top: 4px;
}

.dots:after {
  display: inline-flex;
  background: radial-gradient(circle, #c4c4c4 2px, transparent 2px) repeat-x;
  background-size: 10px 25px;
  border: none;
  flex-grow: 5;
}

.bi {
  color: #262c66;
}

.bi-geo-alt-fill::before {
  font-size: 16px;
}

.modal-footer {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-bottom: 2.5rem;
  height: 4rem;
}

.modal-footer button {
  width: 12.2rem;
  background: #262c66;
  border-radius: 4px;
  color: #fff;
  margin: 1rem;
  font-size: 1rem;
}

.modal-footer a {
  margin: 1rem;
  color: #ffffff;
  font-size: 1rem;
  text-decoration: none;
}

.modal-footer a button {
  background: none;
  color: #0d0d0d;
}

p.adjust-row {
  margin-top: -2px;
}

.multiselect {
  margin: 0;
  width: 350px;
}

.multiselect-tags {
  font-size: 10px;
}
</style>
